module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-page-header', {
    attrs: {
      "content": _vm.$route.query.id != undefined ? '商品编辑' : '商品添加'
    },
    on: {
      "back": _vm.goBack
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品标题"
    }
  }, [_c('el-input', {
    attrs: {
      "rules": {
        required: true,
        message: '商品标题',
        trigger: 'blur'
      }
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品分类"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择分类",
      "rules": {
        required: true,
        message: '商品标题',
        trigger: 'blur'
      }
    },
    model: {
      value: (_vm.form.category_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "category_id", $$v)
      },
      expression: "form.category_id"
    }
  }, _vm._l((_vm.category), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.category_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品信息"
    }
  }, [(_vm.form.goods_info != undefined && _vm.form.goods_info[0] != undefined) ? _c('div', {
    staticClass: "goods",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "goods-thumbnail"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": _vm.form.goods_info[0].pics,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "goods-caption"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v("\n                " + _vm._s(_vm.form.goods_info[0].item_title) + "\n                "), (_vm.form.goods_info[0].special_type == 'drug') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("处方药")]) : _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("非处方药")]), _vm._v(" "), _c('span', {
    staticClass: "goods-remove iconfont icon-trash-alt",
    on: {
      "click": function($event) {
        return _vm.handleSkuRemove()
      }
    }
  })])])]) : _c('div', [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否厂家合作"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_manufactor),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_manufactor", $$v)
      },
      expression: "form.is_manufactor"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品是否可用"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_can_use),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_can_use", $$v)
      },
      expression: "form.is_can_use"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "过期方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("灵活过期(自签约之日起按有效期灵活过期)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("统一过期(统一过期时间设定后，请勿随意更改)")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.begin_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "begin_time", $$v)
      },
      expression: "form.begin_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择时间",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.end_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_time", $$v)
      },
      expression: "form.end_time"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.type == 0) ? _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "活动时间(天数)"
    },
    model: {
      value: (_vm.form.days),
      callback: function($$v) {
        _vm.$set(_vm.form, "days", $$v)
      },
      expression: "form.days"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "共x期限，最高省X元"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合约说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠券激活策略"
    }
  }, [_vm._l((_vm.form.rule), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": '规则.' + (index + 1),
        "prop": 'rule.' + index + '.value',
        "rules": _vm.rules
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择优惠券",
        "filterable": ""
      },
      on: {
        "change": function($event) {
          return _vm.changeCard(index)
        }
      },
      model: {
        value: (item.card_id),
        callback: function($$v) {
          _vm.$set(item, "card_id", $$v)
        },
        expression: "item.card_id"
      }
    }, _vm._l((_vm.cardList), function(v, i) {
      return _c('el-option', {
        key: v.card_id,
        attrs: {
          "label": v.title,
          "value": v.card_id
        }
      })
    }), 1), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "100px",
        "display": "none"
      },
      attrs: {
        "placeholder": "等级"
      },
      model: {
        value: (item.level),
        callback: function($$v) {
          _vm.$set(item, "level", $$v)
        },
        expression: "item.level"
      }
    }), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "placeholder": "数量"
      },
      model: {
        value: (item.number),
        callback: function($$v) {
          _vm.$set(item, "number", $$v)
        },
        expression: "item.number"
      }
    }, _vm._l((20), function(v, i) {
      return _c('el-option', {
        key: i,
        attrs: {
          "label": v,
          "value": v
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "自领券后多少天过期"
      },
      model: {
        value: (item.expiry_time),
        callback: function($$v) {
          _vm.$set(item, "expiry_time", $$v)
        },
        expression: "item.expiry_time"
      }
    }, _vm._l((100), function(v, i) {
      return _c('el-option', {
        key: i,
        attrs: {
          "label": v,
          "value": v
        }
      })
    }), 1), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "text",
        "placeholder": "说明(第~几盒)"
      },
      model: {
        value: (item.message),
        callback: function($$v) {
          _vm.$set(item, "message", $$v)
        },
        expression: "item.message"
      }
    }), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "text"
      },
      model: {
        value: (item.info),
        callback: function($$v) {
          _vm.$set(item, "info", $$v)
        },
        expression: "item.info"
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRule(item)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addRule
    }
  }, [_vm._v("+增加规则")])], 2), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-196616b3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-196616b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/long/goods/edit.vue
// module id = 2506
// module chunks = 0